import React from 'react';

export const NoSelectionIllustration: React.FC = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M89.86 85.0696L20.29 72.7796L25.21 36.8896L94.97 49.2096L89.86 85.0696Z"
          fill="#C2E2FF"
        />
        <path
          d="M79.5199 37.19L16.7299 64.94L0.919922 32.54L63.8799 4.70996L79.5199 37.19Z"
          fill="#116DFF"
        />
        <path
          d="M53.3101 23.0498C55.2431 23.0498 56.8101 21.4828 56.8101 19.5498C56.8101 17.6168 55.2431 16.0498 53.3101 16.0498C51.3771 16.0498 49.8101 17.6168 49.8101 19.5498C49.8101 21.4828 51.3771 23.0498 53.3101 23.0498Z"
          fill="white"
        />
        <path
          d="M57 23.19L62.4 17C64.6043 18.9274 65.6129 21.8845 65.0459 24.7572C64.4788 27.6299 62.4223 29.9819 59.6509 30.9272C56.8795 31.8725 53.8143 31.2674 51.61 29.34L51.5 29.25L57 23.19Z"
          fill="white"
        />
        <path d="M87.0898 74.0096H13.7798L12.3198 37.8096H85.8298L87.0898 74.0096Z" fill="white" />
        <path
          d="M72 60.0001V61.0001H47V60.0001H72ZM64 55.0001V56.0001H47V55.0001H64ZM74.79 15.3301L75.59 15.5601C82 17.5101 91 23.1201 89.81 30.7201C89.7041 31.4402 89.3915 32.1142 88.91 32.6601C90.1246 34.82 90.8995 37.1991 91.19 39.6601C91.7047 43.4535 90.9599 47.311 89.07 50.6401L88.21 50.1401C89.9962 46.9964 90.699 43.3526 90.21 39.7701C89.9667 37.511 89.2875 35.3205 88.21 33.3201L87.88 33.5001C86.4028 34.1655 84.7008 34.1101 83.27 33.3501C82.6526 33.0533 82.1728 32.5306 81.93 31.8901C81.705 31.3574 81.7306 30.7518 82 30.2401C82.3773 29.644 82.9931 29.2395 83.69 29.1301C84.7841 29.0443 85.8662 29.405 86.69 30.1301C87.275 30.6148 87.7988 31.1689 88.25 31.7801C88.5065 31.4099 88.6741 30.9856 88.74 30.5401C89.34 26.7201 86.27 19.8501 75.3 16.5401L74.54 16.3301L74.79 15.3301ZM84.14 30.1001H83.87C83.4597 30.1584 83.0948 30.3919 82.87 30.7401C82.7136 30.9802 82.6767 31.2791 82.77 31.5501C82.9371 31.9426 83.2434 32.2596 83.63 32.4401C84.7739 33.0589 86.1397 33.1143 87.33 32.5901L87.56 32.4601C87.1407 31.884 86.6539 31.3603 86.11 30.9001C85.5539 30.4327 84.8645 30.1527 84.14 30.1001Z"
          fill="#192C55"
        />
        <path
          d="M26.4399 54.96C28.7872 54.96 30.6899 53.0572 30.6899 50.71C30.6899 48.3628 28.7872 46.46 26.4399 46.46C24.0927 46.46 22.1899 48.3628 22.1899 50.71C22.1899 53.0572 24.0927 54.96 26.4399 54.96Z"
          fill="#FCA760"
        />
        <path
          d="M30.62 55.4199L37.67 48.4199C40.8854 52.4032 40.5735 58.1715 36.9473 61.7848C33.3212 65.3981 27.5517 65.6895 23.58 62.4599L23.46 62.3399L30.62 55.4199Z"
          fill="#FFD527"
        />
      </g>
    </svg>
  );
};
